import { AfterViewInit, Component, Injector, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppConsts } from '@shared/AppConsts';
import { SubscriptionStartType } from '@shared/AppEnums';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import * as moment from 'moment';
import { AppComponentBase } from 'shared/common/app-component-base';
import { SettingService } from 'services/project.service';
import { SignalRHelper } from 'shared/helpers/SignalRHelper';
import { CommonLookupServiceProxy } from '@shared/service-proxies/service-proxies';
import { PdfReportServiceProxy } from '@shared/service-proxies/service-proxy-rpt';

import { saveAs } from 'file-saver';
import { SwUpdate } from '@node_modules/@angular/service-worker';
import { interval } from '@node_modules/rxjs';
import { PwaInstallService } from '@shared/service-proxies/EventEmitterService';
import { Title } from '@node_modules/@angular/platform-browser';



@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit, AfterViewInit {
    public failedCalculationsDetailed: any = [];
    public CalculationReportInput: any = {};

    private viewContainerRef: ViewContainerRef;
    private router: Router;
    public undoDeleteToastrOption: ToastrOptions = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "preventDuplicates": false,
        "positionClass": "toast-bottom-left",
        "showDuration": 0,
        "hideDuration": 0,
        "timeOut": 15000,
        "extendedTimeOut": 15000,
        "onclick": null,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
    subscriptionStartType = SubscriptionStartType;
    installationMode = true;

    public constructor(
        injector: Injector,
        viewContainerRef: ViewContainerRef,
        private _router: Router,
        private route: ActivatedRoute,
        private swUpdate: SwUpdate,
        private _appSessionService: AppSessionService,
        private _settingService: SettingService,
        private _pdfReportSerivceProxy: PdfReportServiceProxy,
        public pwa: PwaInstallService,
        private title: Title,
        private _commonLookupServiceProxy: CommonLookupServiceProxy) {
        super(injector);

        this.viewContainerRef = viewContainerRef; // You need this small hack in order to catch application root view container ref (required by ng2 bootstrap modal)
        this.router = _router;
        this.router.events.subscribe((val) => {
            this._settingService.hidenavbar();
        })

        if (this.swUpdate.isEnabled) {
            // Periodically check for updates every 5 minutes
            interval(5 * 60 * 1000).subscribe(() => this.swUpdate.checkForUpdate());
        }
    }

    ngOnInit(): void {
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        if (this.appSession.application) {
            SignalRHelper.initSignalR(() => {
                var chatHub = null;
                abp.log.level = abp.log.levels.ERROR;
                // abp.signalr.connect();
                abp.signalr.startConnection(abp.appPath + 'signalr', connection => {
                    console.log('SignalR connected with ID:', connection.connectionId);
                    chatHub = connection; // Save a reference to the hub

                    connection.on('getMessage', message => { // Register for incoming messages

                        if (typeof message === 'string') {
                            if (message == "Role_Updated") {
                                window.location.reload();
                            }
                            else if (message == "User_Added") {
                                if (this._router.url.indexOf('/app/main/manage-account') > -1) {
                                    window.location.reload();
                                }
                            }
                            else if (message == "User_Updated") {
                                if (this._router.url.indexOf('/app/main/manage-account') > -1) {
                                    window.location.reload();
                                }
                            }
                            else if (message == "QueueStarted") {
                                // const $toast = toastr.success(
                                //     `<h5>Updating Calculations</h5><span>The update has started in the background. Once it is complete, you will be notified here and by email, and the calculations will be ready to use.</span>`, ``,
                                //     this.undoDeleteToastrOption
                                // );
                                //window.location.reload();
                            }
                        }
                        else {
                            if (message.status == "QueueError") {
                                // const $toast = toastr.success(
                                //     `<h5>Update Completed With Errors</h5><span>Some calculations could not be updated due to a technical error. A summary has been sent to email and the failed list has been downloaded. Please contact support for further assistance.</span>`, ``,
                                //     this.undoDeleteToastrOption
                                // );
                                const failedCalculations = message.calculationStatus.filter(c => c.status != 1);
                                this.failedCalculationsDetailed = failedCalculations.map(failed => {
                                    const matched = message.calculationStatus.find(c => c.calculationId === failed.calculationId);
                                    return {
                                        calculationId: failed.calculationId,
                                        name: matched?.calculationName || 'Unknown',
                                        calculationType: this.getCalculationTypeName(matched?.calculationType)

                                    };
                                });
                                this.DownloadFailedUpgradedCalculations(message.projectName);
                                this.CalculationReportInput.calculationIds = message.calculationIds;
                                this.CalculationReportInput.projectid = message.projectId;
                                this.CalculationReportInput.queueid = message.queueId;
                                this.DownloadReportsUpgradedCalculations(this.CalculationReportInput, message.projectName, message.projectId);

                            }
                            else if (message.status == "QueueCompleted") {

                                // const $toast = toastr.success(
                                //     `<h5>Calculations Updated</h5><span>The update is complete. The calculations are now ready to open or edit. Please refer to the email summary for more details.</span>`, ``,
                                //     this.undoDeleteToastrOption
                                // );
                                this.CalculationReportInput.calculationIds = message.calculationIds;
                                this.CalculationReportInput.projectid = message.projectId;
                                this.CalculationReportInput.queueid = message.queueId;
                                this.DownloadReportsUpgradedCalculations(this.CalculationReportInput, message.projectName, message.projectId);


                            }
                        }

                    });

                    connection.on('CalculationDeleted', (data: any) => {
                        this.handleCalculationDeleted(data);
                    });

                    connection.onclose(e => {
                        if (e) {
                            // abp.log.debug('Chat connection closed with error: ' + e);
                        }
                        else {
                            // abp.log.debug('Caht disconnected');
                        }

                        if (!abp.signalr.autoConnect) {
                            return;
                        }

                        setTimeout(() => {
                            connection.start().then(result => {
                            });
                        }, 1000);
                    });

                }).then(function (connection) {
                    // abp.log.debug('Connected to myChatHub server!');
                });
            });
        }

        this.updateVisibility(this.router.url);
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.updateVisibility(event.url);
            }
        });

    }

    getCalculationTypeName(calculationType) {
        var calculationTypeStr = 'CableSizeAUS';
        if (calculationType === 3) {
            calculationTypeStr = 'CableSizeBS';
        }
        else if (calculationType === 4) {
            calculationTypeStr = 'AutoMaxDemand';

        }
        else if (calculationType === 5) {
            calculationTypeStr = 'ProtectiveCoordination';

        }
        else if (calculationType === 6) {
            calculationTypeStr = 'CablePulling';

        }
        else if (calculationType === 7) {
            calculationTypeStr = 'NetworkCalculation';

        }
        else if (calculationType === 8) {
            calculationTypeStr = 'ArcFlash';

        }
        else if (calculationType === 9) {
            calculationTypeStr = 'CableSizeIEC';

        }
        else if (calculationType === 12) {
            calculationTypeStr = 'CableSizeNEC';

        }
        return calculationTypeStr;
    }
    DownloadReportsUpgradedCalculations(inputCalculationIds, filename = "Reports", projectid) {
        this._pdfReportSerivceProxy
            .DownloadZipOfMultipleReportFromS3(inputCalculationIds)
            .subscribe((response: any) => {
                if (!response.body || response.body.size === 0) {
                    // handle empty
                } else {
                    // ✅ Try to extract filename from headers
                    let fileNameFromServer = filename + ".zip"; // fallback
                    const contentDisposition = response.headers.get('content-disposition');

                    if (contentDisposition) {
                        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            fileNameFromServer = matches[1].replace(/['"]/g, '');
                        }
                    }

                    const blob = new Blob([response.body], { type: 'application/zip' });
                    saveAs(blob, fileNameFromServer);
                }

                // ✅ store and reload
                sessionStorage.setItem('upgradeCompleted', projectid);
                if (/\/app\/main\/projects\/\d+\/calcs(\?|$)/.test(this._router.url)) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            },
                () => {
                    // error handling
                });
    }

    DownloadFailedUpgradedCalculations(projectName: string) {
        if (!this.failedCalculationsDetailed?.length) {
            return; // No failed calculations, nothing to download
        }

        // Intro line
        const intro = `The update process for the following calculations in the project "${projectName}" was unsuccessful:\n`;

        // Header + rows with alphabet numbering
        const header = "Calculation Type - Calculation Name";
        const rows = this.failedCalculationsDetailed.map((calc, index) => {
            const letter = String.fromCharCode(65 + index); // A, B, C...
            return `${letter}. ${calc.calculationType} - ${calc.name}`;
        });

        // Combine content
        const content = [intro, header, ...rows].join('\n');

        // Safe filename
        const safeProjectName = projectName.replace(/[^a-z0-9]/gi, '_');
        const fileName = `${safeProjectName}_Failed_Updated_Calculations.txt`;

        // Trigger download
        this.downloadTextFile(content, fileName);
    }


    private handleCalculationDeleted(data) {
        const currentUrl = this.router.url; // current path

        // One generic regex to capture pid and cid
        const calcPattern = /\/(?<pid>\d+)\/(calcs|networkcalc|arcflash|calcp|pdccalcs|au-calcs|nz-calcs|bscalcs|automaxd|iec-calcs)\/(?<cid>\d+)/;

        const match = currentUrl.match(calcPattern);

        if (match) {
            const pid = +match.groups['pid']; // projectId from URL
            const cid = +match.groups['cid']; // calculationId from URL

            // Compare with signal data
            if (pid === data.projectId && cid === data.calculationId) {
                toastr.error(
                    `<span>The calculation you are trying to access has been deleted and is no longer available.</span>`,
                    ``
                );
                // Redirect to project list
                this.router.navigate([
                    `/app/main/projects/${data.projectId}/calcs`
                ]);
            }
            // this.router.navigate(['/app/main/projects/' + data.projectId + '/calcs?name=' + 'abc']);
        }
    }

    private updateVisibility(url: string): void {
        const isWebfacing = this.route.snapshot.data['webfacing'];
        if (isWebfacing) {
            this._settingService.IsWebFacing = true;
        }
        else {
            this._settingService.IsWebFacing = false;
        }
    }

    checkApiStatus() {
        const obs = this._commonLookupServiceProxy.ping();
        if (obs) { obs.subscribe(); }
    }

    subscriptionStatusBarVisible(): boolean {
        return this._appSessionService.tenantId > 0 &&
            (this._appSessionService.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this._appSessionService.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this._appSessionService.tenant.subscriptionEndDateUtc);
        }

        return false;
    }
    // hidenavbar()
    // {
    //     if($("#m_ver_menu ul>li").length==0)
    //         {
    //             $(".m-brand__tools").css('display','none');
    //             $("#m_aside_left").css('display','none');
    //             $("#DivAdmin").addClass("nonadmincls");
    //         }
    //         else
    //         {
    //             $(".m-brand__tools").css('display','table-cell');
    //             $("#m_aside_left").css('display','block');
    //             $("#DivAdmin").removeClass("nonadmincls");
    //         }

    // }
    ngAfterViewInit(): void {
        this.checkApiStatus();
        setInterval(() => {
            this.checkApiStatus();
        }, 60000); // Check every 60 seconds
        if (mApp.initialized) {
            return;
        }

        if ($("#m_ver_menu ul>li").length == 0) {
            // $(".m-brand__tools").css('display','none');
            $("#m_aside_left_hide_toggle").css('visibility', 'hidden');
            $("#m_aside_left_offcanvas_toggle").css('visibility', 'hidden');
            $("#m_aside_left").css('display', 'none');
            $("#DivAdmin").addClass("nonadmincls");
        }
        else {
            $(".m-brand__tools").css('display', 'table-cell');
            $("#m_aside_left").css('display', 'block');
            $("#DivAdmin").removeClass("nonadmincls");
        }


        this._settingService.hidenavbar();

        mApp.init();
        mLayout.init();
        mApp.initialized = true;

        setTimeout(() => {
            this.disableGrammarlyGlobally();
        }, 1500);
    }

    private disableGrammarlyGlobally(): void {
        const apply = (el: HTMLElement) => {
            el.setAttribute('data-gramm', 'false');
            el.setAttribute('data-gramm_editor', 'false');
            el.setAttribute('data-enable-grammarly', 'false');
            el.setAttribute('spellcheck', 'false');
        };

        // Apply to existing inputs
        document
            .querySelectorAll<HTMLElement>('textarea, input[type="text"], input[type="email"], input[type="search"]')
            .forEach(apply);

        // Apply to dynamically added inputs
        const observer = new MutationObserver(() => {
            document
                .querySelectorAll<HTMLElement>('textarea, input[type="text"], input[type="email"], input[type="search"]')
                .forEach(apply);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    reloadBtn(): void {
        window.location.reload();
    }

    showPopup = false;
}
